'use strict';

angular.module('app.networkManageInfluencers', ['ui.router', 'angular-img-cropper', 'sotos.crop-image'])

.config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {   
        $stateProvider
            .state('home.networkProfileManageInfluencers', {
                requireLogin: true,
                url: 'profile/manageinfluencers',
                templateUrl: 'app/profile/networkManageInfluencers/partials/network-login-manage-influencers.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User'],
                    navMarker: ['profile', 'networkManageInfluencers']
                },
                controller: 'NetworkManageInfluencersCtrl'
            })
}])

.controller('NetworkManageInfluencersCtrl', function($scope, $rootScope, $http, $modal, $location, localStorageService, $animate, adminService){
    $scope.currentUser = $rootScope.currentUser;

    $scope.networkInfluencers = $rootScope.allInfluencerByNetworkCompany;
    
    $scope.PlatformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.$watch('networkInfluencerList', function(newValue, oldValue){
        if(newValue !== oldValue && newValue !== undefined) {
            if(newValue[0] != null){
                $scope.selectedNetworkInfluencer = newValue[0];
            }
            
        }
    });
});

    
